// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.section-tree-root {
  padding: 0.5rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
.section-tree-root .sections-view {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
.section-tree-root .single-section-view {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 0.5rem;
}
.section-tree-root .single-section-view h4 {
  margin: 0 0 0.75rem 0;
  font-size: 1rem;
  font-weight: 600;
  color: #667eea;
}
.section-tree-root .single-section-view .child-sections {
  padding: 1rem;
  background: rgba(102, 126, 234, 0.03);
  border-radius: 8px;
  border: 1px solid rgba(102, 126, 234, 0.1);
}
.section-tree-root .single-section-view .child-sections h4 {
  margin: 0 0 0.75rem 0;
  font-size: 1rem;
  font-weight: 600;
  color: #667eea;
}
.section-tree-root .section-item.root {
  font-weight: 700;
  font-size: 0.9rem;
  border-bottom: 2px solid rgba(102, 126, 234, 0.2);
  padding: 0.75rem 1rem;
  background: linear-gradient(135deg, rgba(102, 126, 234, 0.08) 0%, rgba(118, 75, 162, 0.08) 100%);
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
.section-tree-root .section-item.root .root-icon {
  font-size: 1.2rem;
  color: #667eea;
}
.section-tree-root .section-item.root:hover {
  background: linear-gradient(135deg, #f8f9ff 0%, #e9ecff 100%);
  box-shadow: 0 2px 8px rgba(102, 126, 234, 0.15);
}
.section-tree-root .section-item.root.selected {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
}
.section-tree-root .section-item.root.selected .root-icon {
  color: white;
}
.section-tree-root .sections-horizontal {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  align-items: flex-start;
}
.section-tree-root .sections-horizontal .section-box-container {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  align-items: flex-start;
}
.section-tree-root .sections-horizontal .subsections-container {
  width: 100%;
  margin-top: 0.25rem;
  padding: 0.5rem;
  border-radius: 8px;
  background: rgba(102, 126, 234, 0.03);
  border: 1px solid rgba(102, 126, 234, 0.1);
}
.section-tree-root .sections-horizontal .subsections-container .section-tree-root {
  padding: 0;
}`, "",{"version":3,"sources":["webpack://./src/app/shaps/pages/catalog-admin/catalog-manager/section-tree/section-tree.component.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;AACF;AACE;EACE,aAAA;EACA,sBAAA;EACA,WAAA;AACJ;AAEE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,eAAA;AAAJ;AAEI;EACE,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAAN;AAGI;EACE,aAAA;EACA,qCAAA;EACA,kBAAA;EACA,0CAAA;AADN;AAGM;EACE,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AADR;AAME;EACE,gBAAA;EACA,iBAAA;EACA,iDAAA;EACA,qBAAA;EACA,gGAAA;EACA,kBAAA;EACA,eAAA;EACA,iDAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;AAJJ;AAMI;EACE,iBAAA;EACA,cAAA;AAJN;AAOI;EACE,6DAAA;EACA,+CAAA;AALN;AAQI;EACE,6DAAA;EACA,YAAA;AANN;AAQM;EACE,YAAA;AANR;AAWE;EACE,aAAA;EACA,eAAA;EACA,WAAA;EACA,uBAAA;AATJ;AAWI;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,uBAAA;AATN;AAYI;EACE,WAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,qCAAA;EACA,0CAAA;AAVN;AAYM;EACE,UAAA;AAVR","sourcesContent":[".section-tree-root {\n  padding: 0.5rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n\n  .sections-view {\n    display: flex;\n    flex-direction: column;\n    gap: 0.5rem;\n  }\n\n  .single-section-view {\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n    padding: 0.5rem;\n\n    h4 {\n      margin: 0 0 0.75rem 0;\n      font-size: 1rem;\n      font-weight: 600;\n      color: #667eea;\n    }\n\n    .child-sections {\n      padding: 1rem;\n      background: rgba(102, 126, 234, 0.03);\n      border-radius: 8px;\n      border: 1px solid rgba(102, 126, 234, 0.1);\n\n      h4 {\n        margin: 0 0 0.75rem 0;\n        font-size: 1rem;\n        font-weight: 600;\n        color: #667eea;\n      }\n    }\n  }\n\n  .section-item.root {\n    font-weight: 700;\n    font-size: 0.9rem;\n    border-bottom: 2px solid rgba(102, 126, 234, 0.2);\n    padding: 0.75rem 1rem;\n    background: linear-gradient(135deg, rgba(102, 126, 234, 0.08) 0%, rgba(118, 75, 162, 0.08) 100%);\n    border-radius: 8px;\n    cursor: pointer;\n    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n\n    .root-icon {\n      font-size: 1.2rem;\n      color: #667eea;\n    }\n\n    &:hover {\n      background: linear-gradient(135deg, #f8f9ff 0%, #e9ecff 100%);\n      box-shadow: 0 2px 8px rgba(102, 126, 234, 0.15);\n    }\n\n    &.selected {\n      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n      color: white;\n\n      .root-icon {\n        color: white;\n      }\n    }\n  }\n\n  .sections-horizontal {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 0.5rem;\n    align-items: flex-start;\n\n    .section-box-container {\n      display: flex;\n      flex-direction: column;\n      gap: 0.25rem;\n      align-items: flex-start;\n    }\n\n    .subsections-container {\n      width: 100%;\n      margin-top: 0.25rem;\n      padding: 0.5rem;\n      border-radius: 8px;\n      background: rgba(102, 126, 234, 0.03);\n      border: 1px solid rgba(102, 126, 234, 0.1);\n      \n      .section-tree-root {\n        padding: 0;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
